// extracted by mini-css-extract-plugin
export default {"Flash":"PlanSupportBanner-module__Flash--IuApX","Box":"PlanSupportBanner-module__Box--ly6Nh","Text":"PlanSupportBanner-module__Text--rvwbA"};